import { Mixins, Component } from 'vue-property-decorator'
import gql from 'graphql-tag'

import { Language } from '@/@types/graphql'
import DatasetService from './Dataset'

@Component({ name: 'languages-service' })
export default class Languages extends Mixins(DatasetService) {

  async GET_ALL_LANGUAGES (isEnabled: boolean = true): Promise<Language[]> {
    const variables = { isEnabled }
    const query = gql`
      query languages ($isEnabled: Boolean) {
        languages (isEnabled: $isEnabled) {
          id,
          iso,
          code,
          name,
          flag
        }
      }
    `
    const { data } = await this.$apollo.query({ query, variables })
    return data.languages
  }

  async FETCH_AVAILABLE_TARGETS () {
    const data = await this.GET_DATASET('translatableTargets')   
    return data?.value || []
  }

}
